var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 9.5V13C1.5 14.6569 2.84315 16 4.5 16V16M1.5 9.5C1.5 9.5 3.5 11 7 11C10.5 11 16.5 11 16.5 11M1.5 9.5C1.5 9.5 0.5 9 0.5 8C0.5 7.67741 0.685002 7.44732 0.89586 7.28984C1.24607 7.02829 1.71717 7.09387 2.12448 7.25247C2.19012 7.27803 2.26005 7.30499 2.33384 7.33309M16.5 11V13C16.5 14.6569 15.1569 16 13.5 16V16M16.5 11C16.5 11 18 11 18 9.75C18 8.5 16.5 8.5 16.5 8.5C16.5 8.5 9 8.5 7 8.5C5.60958 8.5 3.49417 7.77502 2.33384 7.33309M4.5 16L3.5 18M4.5 16H13.5M13.5 16L14.5 18M2.33384 7.33309V2.33308C2.33384 1.3207 3.15454 0.5 4.16692 0.5V0.5C5.1793 0.5 6 1.3207 6 2.33308V2.5M6 2.5V2.5C5.17157 2.5 4.5 3.17157 4.5 4V5H7.5V4C7.5 3.17157 6.82843 2.5 6 2.5V2.5Z",
    stroke: "#097FE6",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.1e5f2ff5e2c11ef23a910ad9f4cd5924.svg";
export { ForwardRef as ReactComponent };